/**
 * i18n-Geruest.
 *
 * CLAUDE.md, Sprachregelung: "Alle UI-Strings laufen über i18n (`de` als
 * Standard, `en` vorbereitet). Keine deutschen Strings hart im Code."
 *
 * Beide Sprachdateien werden fest eingebunden und nicht nachgeladen. Bei zwei
 * Sprachen und wenigen Kilobyte waere das Nachladen Aufwand ohne Nutzen -- und
 * es brachte eine zweite Fehlerquelle mit: eine Oberflaeche, die kurzzeitig
 * die Schluessel statt der Texte zeigt.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './de.json';
import en from './en.json';

export const DEFAULT_LANGUAGE = 'de';
export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    // React entschaerft Zeichenketten bereits beim Einsetzen. Eine zweite
    // Entschaerfung durch i18next machte aus Umlauten Entitaeten.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;

/**
 * Der Ort, an dem die Anzeigezone festgelegt ist.
 *
 * docs/02, Abschnitt 1: Alle Zeitstempel kommen als UTC vom Server, die
 * Darstellung erfolgt in `Europe/Berlin`. Steht das an einer Stelle, laesst
 * es sich spaeter je Mandant aus `tenants.timezone` versorgen, ohne jede
 * Komponente anzufassen.
 */
export const DISPLAY_TIME_ZONE = 'Europe/Berlin';

export function formatDateTime(value: string, language: string = DEFAULT_LANGUAGE): string {
  return new Intl.DateTimeFormat(language, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: DISPLAY_TIME_ZONE,
  }).format(new Date(value));
}

export function formatDate(value: string, language: string = DEFAULT_LANGUAGE): string {
  return new Intl.DateTimeFormat(language, {
    dateStyle: 'medium',
    timeZone: DISPLAY_TIME_ZONE,
  }).format(new Date(value));
}
